module.exports = __webpack_public_path__ + "static/media/brand.b9d33e01.svg";